import React from 'react';
import AddOnCard from './AddOnCard';

type MkpPlanCardV2Props = {
  hasAdvancedMode: boolean;
  numTenants: number;
  maxTenants: number;
};
const MkpPlanCardV2 = ({ hasAdvancedMode, numTenants, maxTenants }: MkpPlanCardV2Props) => (
  <AddOnCard
    title="My Kentik Portal"
    description={`KD-MT${hasAdvancedMode ? '-ADV' : ''}`}
    extensions={[
      { key: 'MKP Tenants', value: `${numTenants} of ${hasAdvancedMode ? 'Unlimited' : maxTenants}` },
      { key: 'Advanced Feature Set', value: hasAdvancedMode ? 'Enabled' : 'Disabled' }
    ]}
  />
);

export default MkpPlanCardV2;
